<fui-image-control [disabled]="isReadonly" [label]="label"
                   [placeholder]="placeholder" [placeholderImage]="placeholderImage"
                   [attr.id]="elementId"
                   [(ngModel)]="value" [control]="formControl" [maxImageSize]="maxImageSize"
                   [allowSvg]="allowSvg" [showImage]="showImage"
                   [showOpacitySlider]="showOpacitySlider" [(imageOpacity)]="imageOpacity">
</fui-image-control>
